<template>
<component :is="SkinComponent" :boards="boards" :summary="summary" @loadmore="onLoadmore" @page="onPage">
</component>
</template>

<script>
import api from "@/api";

export default {
    props: {
        skin: { type: String, default: null },
        code: { type: String, default: null },
        page: { type: Number, default: 1 },
        skip: { type: Number, default: 0 },
        limit: { type: Number, default: 2 }
    },
    data(){
        return {
            headers: {
                skip: this.$props.skip || (this.$props.page - 1) * this.$props.limit,
                limit: this.$props.limit
            },

            params: {
                code: this.$props.code
            },

            summary: { totalCount: 0 },
            boards: []
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search();
        },
        async search(){
            try{
                var { summary, boards } = await api.v1.boards.getBoards({
                    headers: this.headers,
                    params: this.params
                });

                this.summary = summary;
                this.boards = this.boards.length ? this.boards.concat(boards) : boards;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        onLoadmore(){
            this.headers.skip = this.boards.length;
            this.search();
        },

        onPage(page){
            this.headers.skip = (page - 1) * this.$props.limit;
            this.search();
        }
    },
    computed: {
        SkinComponent(){
            return () => import(`./skin/${this.$props.skin}/list.vue`);
        }
    }
}
</script>